'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptsToValue = exports.SALES_EXTENSION_OPTION = exports.SIDEBAR_OPTION = undefined;

var _OptsToPath;

var _AllowedCustomOpts = require('./AllowedCustomOpts');

var _AllowedCustomOpts2 = _interopRequireDefault(_AllowedCustomOpts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SIDEBAR_OPTION = exports.SIDEBAR_OPTION = 'opt_sidebar';
var SALES_EXTENSION_OPTION = exports.SALES_EXTENSION_OPTION = 'sales-extension-signup';

var OptsToPath = (_OptsToPath = {}, _defineProperty(_OptsToPath, _AllowedCustomOpts2.default.MEETING_SIDEBAR, SIDEBAR_OPTION), _defineProperty(_OptsToPath, _AllowedCustomOpts2.default.SALES_EXTENSION_SIDEBAR, SALES_EXTENSION_OPTION), _OptsToPath);

var OptsToValue = exports.OptsToValue = _defineProperty({}, _AllowedCustomOpts2.default.MEETING_SIDEBAR, 'meeting');

exports.default = OptsToPath;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.15/js/constants/OptsToPath.js
// module id = 429
// module chunks = 0